import { render, staticRenderFns } from "./BookInfo.vue?vue&type=template&id=92b5243c&scoped=true"
import script from "./BookInfo.vue?vue&type=script&lang=js"
export * from "./BookInfo.vue?vue&type=script&lang=js"
import style0 from "./BookInfo.vue?vue&type=style&index=0&id=92b5243c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b5243c",
  null
  
)

export default component.exports